import httpHubless from 'hub-http/clients/noPortalApiClient';
import Endpoints from '../constants/apiEndpoints';
const checkCookieIssuer = () => httpHubless.get(Endpoints.COOKIE_ISSUER_VALID);
export default checkCookieIssuer;